import {Check, Info, Mail, Trophy, Users} from "lucide-react";
import {IPoll, IPollResult, IPollResultOptions, IVoters} from "../../types/poll.types";
import EmployeeAvatar from "../../../employee/avatar/employee-avatar";
import React from "react";
import PollResultGraph from "../result-graph";
import {Button} from "antd";

interface IWinnerResultProps {
    result: IPollResult | undefined;
    selectedPoll: IPoll | null;
    handleDeclareResult: (id: any) => void;
}

const RenderWinnerResult = (props: IWinnerResultProps) => {
    const hadVotePercentage = props.result?.options.every(option => option.votePercentage !== undefined);
    const hadWinnerPercentage = props.result?.options.some((item: IPollResultOptions) => (
        item.votePercentage
    ))
    const hadVoterList = props.result?.options?.some(
        (options: IPollResultOptions) => (
            options.voters
        )
    );

    return (
        <div className={'winner-result-modal'}>

            <div className={'winner-heading'}>
                <div>
                    <h5>Winner</h5>
                </div>
                <div className={'total-vote-count'}>
                    <Users
                        className={'poll-user-icon'}/> {props.selectedPoll?.totalVotes ?? props.selectedPoll?.totalVotes} total
                    votes
                </div>
            </div>
            {hadWinnerPercentage ?
                <div className={'poll-result-container'}>
                    <div className={'trophy-icon'}>
                        <Trophy/>
                    </div>
                    <div className={'winner-option'}>
                        <div>
                            {props.result?.options.map((item: IPollResultOptions) => (item.isWinner ? item.option : ""))}
                        </div>
                    </div>

                    <div className={'vote-percentage'}>
                        {
                            props.result?.options.map((item) => (
                                item.isWinner ? `${item.votePercentage} %` : ""
                            ))
                        }
                    </div>
                </div> :
                <div className={'Single-winner-result-details'}>
                    {props.result?.options.map((item: IPollResultOptions) => (
                        item.isWinner && <div className={'single-vote-winner-details'}>
                            <div className={'trophy-icon'}>
                                <Trophy/>
                            </div>
                            <div className={'option-note'}>
                                <h4> {item.option} </h4>
                                <div className={'sub-text-one'}>
                                    Received the most votes out of {props.result?.totalVotes} total
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className={'options-heading'}>
                        <h6>OPTIONS</h6>
                    </div>
                    <div className="result-option-list">
                        {props.result?.options.map((item: IPollResultOptions, index: number) => (
                            <div
                                key={item.optionId}
                                className={`result-option-card ${item.isWinner ? "winner" : ""}`}
                            >
                                <div className="option-left">
                                    <div className={`option-number ${item.isWinner ? "winner" : ""}`}>
                                        {index + 1}
                                    </div>

                                    <div className="option-content">
                                        <div className="option-title">
                                            {item.option}
                                        </div>

                                        <div className={`option-subtitle ${item.isWinner ? "winner" : "looser"}`}>
                                            {item.isWinner ? "Most voted option" : " "}
                                        </div>
                                    </div>
                                </div>

                                <div className="option-right">
                                    {item.isWinner ? (
                                        <div className="winner-badge">
                                            <Trophy size={14}/>
                                            Winner
                                        </div>
                                    ) : (
                                        <> </>
                                    )}
                                </div>
                            </div>
                        ))}

                        <div className="result-info">
                            <Info size={18}/>
                            <span>Vote percentages are not included in this result. Only the winner is
            determined from the available data.</span>
                        </div>
                    </div>
                </div>
            }
            {
                hadVotePercentage && <div>
                    <PollResultGraph result={props.result}/>
                </div>
            }

            {
                !props.selectedPoll?.active && props.selectedPoll?.anonymous && !props.selectedPoll?.resultDeclared &&
                <Button type={"primary"} className={'declare-result-btn'}
                        onClick={() => props.handleDeclareResult(props.selectedPoll?.id)}>
                    <Check className={'poll-action-icon'}/> Declare Result
                </Button>
            }

            {
                hadVoterList && <div className={'voter-list-heading'}>
                    <h5> Voters List</h5>
                </div>
            }

            {hadVoterList && <div className={'voter-list-container'}>

                {props.result?.options?.map((item) => (
                    item?.voters?.map((voters: IVoters) => (
                        <div className={'voter-details'}>
                            <div>
                                <EmployeeAvatar
                                    thumbnailId={voters.profilePhotoThumbnailId}
                                    name={{
                                        firstName: voters.name?.firstName,
                                        lastName: voters.name?.lastName
                                    }}
                                />
                            </div>
                            <div className={'voters-name'}>
                                <div>
                                    {voters.name.firstName} {voters.name.middleName} {voters.name.lastName} voted
                                    for <b>{item.option}</b>
                                </div>
                                <div>
                                    <Mail className={'voters-email'}/> {voters.officialEmail}
                                </div>
                            </div>
                        </div>
                    ))
                ))}

            </div>}
        </div>
    )
}

export default RenderWinnerResult;